import { sourceColors, sourceLabels } from "../data/leads.mock";
import type { LeadSource } from "../types/lead.types";

type LeadSourceBadgeProps = {
	source: LeadSource;
};

export function LeadSourceBadge({ source }: LeadSourceBadgeProps) {
	return <span className={`crm-badge ${sourceColors[source]}`}>{sourceLabels[source]}</span>;
}
